import React from "react";
import PropTypes from "prop-types";
import style from "./MainNavbar.module.sass";
import LogoutIcon from "./LogoutIcon/LogoutIcon";
import CenterSelector from "../CenterSelector/CenterSelector";
import { callApi } from "../../helpers";

function MainNavbar(props) {
  const {
    translations,
    avatar,
    defaultAvatar,
    logoutURL,
    tooltipLogout,
    tooltipProfile,
    profileURL,
    dev,
    devURL,
    centers,
    currentCenterId,
    centerSelectionURL,
    csrfToken,
  } = props;

  const onClickDev = (e) => {
    e.preventDefault();
    callApi(devURL, "POST", "json");
  };

  const onCenterChange = (e) => {
    e.target.form.submit();
  };

  return (
    <nav className={`${style.MainNavbar}`}>
      <div id="uber-title" className={`${style.title}`}>
        {translations.title}
      </div>

      <div className={`${style.rightButtons}`}>
        {centers.length > 1 && (
          <CenterSelector
            centers={centers}
            currentCenterId={currentCenterId}
            centerSelectionURL={centerSelectionURL}
            csrfToken={csrfToken}
          />
        )}

        {dev && (
          <a
            href="#"
            onClick={onClickDev}
            className="text-primary text-decoration-none"
          >
            Simula la ricezione di un messaggio
          </a>
        )}

        <a
          href={profileURL}
          className="auto-tooltip"
          data-toggle="tooltip"
          title={tooltipProfile}
        >
          <img
            src={avatar ? avatar : defaultAvatar}
            className={`${style.profileButton}`}
          />
        </a>

        <a
          href={logoutURL}
          method="delete"
          rel="nofollow"
          data-method="delete"
          className="auto-tooltip"
          data-toggle="tooltip"
          title={tooltipLogout}
        >
          <LogoutIcon />
        </a>
      </div>
    </nav>
  );
}

MainNavbar.propTypes = {
  centers: PropTypes.array,
  currentCenterId: PropTypes.number,
  centerSelectionURL: PropTypes.string,
  csrfToken: PropTypes.string,
};

MainNavbar.defaultProps = {
  centers: [],
  currentCenterId: null,
};

export default MainNavbar;